const api = {
  GET_LIST_HISTORY_REFUND: '/index.php?r=api/v1/refund_internal/refund/list-history-request-refund',
  GET_DETAIL_HISTORY_REFUND: '/index.php?r=api/v1/refund_internal/refund/detail-history-refund',
};

export default api;
